import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-225" data-mp="1jhk9yn6s8agq">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-226" data-mp="1teg9i3epdm95" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-primary" data-id="element-227" data-mp="1tddmi6ki43yi">:</span>}
          <span className="flex min-w-[68px] flex-col items-center rounded-xl bg-cta px-3 py-2.5 leading-none shadow-glow-cta" data-id="element-228" data-mp="38uxa007v3cc1">
            <b className="text-3xl font-bold tabular-nums tracking-tight text-cta-foreground" data-id="element-229" data-mp="34sk51e0xvigb">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-cta-foreground" data-id="element-230" data-mp="2h6qgj8zltcyf">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}